import type { ImageConfig } from '@archipro-design/aria';
import {
    archiproImageLoader,
    DEVICE_SIZES,
    IMAGE_SIZES,
} from '@archipro-design/aria';

export const imageConfig: Required<ImageConfig> = {
    deviceSizes: [384, ...DEVICE_SIZES],
    imageSizes: IMAGE_SIZES,
    loader: archiproImageLoader(),
    isProduction: import.meta.env.PROD,
};
